module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.465266b2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-SemiBold.ttf
// module id = 2891
// module chunks = 0